// extracted by mini-css-extract-plugin
module.exports = {"arrowItem":"_1858a399","isLeft":"_3ee68474","arrow":"_3025078c"};